import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "@wrappers/layouts/main-layout/Layout";
import { updateActiveModule } from "@features/activeModuleSlice";
import { updateTitle } from "@features/titleSlice";
import { Tabs, TabsProps } from "antd";
import AdminSettingsModal from "@/components/modals/admin-settings/AdminSettingsModal";
import "react-phone-input-2/lib/style.css";
import UserRolesComponent from "./Roles";
import UserComponent from "./Users";
import ClientsComponent from "./Clients";
import ActivityLogsComponent from "./ActivityLogs";
import { checkPermissionIsAllowed, titleCase } from "@/ts/utils";
import {
    AdminSettingsTabs,
    IMainContext,
    ParentModule,
} from "@/ts/common-types";
import { mainContext } from "@/ts/constants";
import { useNavigate } from "react-router-dom";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";
import { useFeatureIsOn } from "@growthbook/growthbook-react";

const AdminSettings = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const showClientsFeature = useFeatureIsOn("CLIENTS_FEATURE") || false;
    const [activeTab, setActiveTab] = useState<AdminSettingsTabs>(
        AdminSettingsTabs.GENERAL
    );

    useEffect(() => {
        dispatch(updateTitle(titleCase(ParentModule.ADMIN_SETTINGS)));
        dispatch(updateActiveModule(ParentModule.ADMIN_SETTINGS));
    }, [dispatch]);

    let items: TabsProps["items"] = [
        {
            key: AdminSettingsTabs.GENERAL,
            label: "General",
            children: (
                <div style={{ height: "80vh" }}>
                    {activeTab === AdminSettingsTabs.GENERAL && (
                        <AdminSettingsModal showAdminSettings={true} />
                    )}
                </div>
            ),
        },
        {
            key: AdminSettingsTabs.USERS,
            label: "Users",
            children: <UserComponent />,
        },
        {
            key: AdminSettingsTabs.ROLES,
            label: "User Roles",
            children: <UserRolesComponent />,
        },
        ...(showClientsFeature
            ? [
                  {
                      key: AdminSettingsTabs.CLIENTS,
                      label: "Clients",
                      children: <ClientsComponent />,
                  },
              ]
            : []),
        {
            key: AdminSettingsTabs.ACTIVITY_LOGS,
            label: "Activity Logs",
            children: <ActivityLogsComponent />,
        },
    ];

    const { canListUsers, canListUserRoles, canListClients } =
        usePermissionCheck();

    items = items.filter((item) => {
        switch (item.key) {
            case AdminSettingsTabs.USERS:
                return canListUsers;
            case AdminSettingsTabs.ROLES:
                return canListUserRoles;
            case AdminSettingsTabs.CLIENTS:
                return canListClients;
            default:
                return true;
        }
    });

    const getActiveKey = items.filter(
        (item) => item.key === window.location.pathname.split("/").pop()
    );

    return (
        <>
            <Layout>
                <Tabs
                    activeKey={
                        getActiveKey[0]?.key || AdminSettingsTabs.GENERAL
                    }
                    items={items}
                    className="m-3 mt-0"
                    onChange={(key) => {
                        setActiveTab(key as AdminSettingsTabs);
                        navigate(
                            `/${ParentModule.ADMIN_SETTINGS}/settings/${key}`
                        );
                    }}
                />
            </Layout>
        </>
    );
};

export default AdminSettings;
